import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import FormattedNumber from '../../../../../../../../../../../components/FormattedNumber'
import Counter from '../../../../../../../../../../../components/Counter'

import Table from './components/Table'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class Debtor extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        summaryData: PropTypes.object,
    }

    render() {
        const { id, module, block, level, summaryData } = this.props

        console.log(summaryData)

        return (
            <div className={'liens-debtor-container'}>
                <div className={'title-container'}>
                    <span className={'highlighted-title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.debtorTitle`} />
                    </span>
                    <FormattedMessage id={`${LOCALE_PREFIX}.skRegister`} />
                </div>
                <div className={'summary-container'}>
                    <div className="row">
                        <div className={'summary-block'}>
                            <Counter
                                leftValue={{
                                    value: _.get(summaryData, 'totalLiens', 0),
                                }}
                                description={
                                    <FormattedMessage id={`${LOCALE_PREFIX}.liensPerDebtor`} values={{ br: <br /> }} />
                                }
                            />
                        </div>
                    </div>
                    <div className={'money-row'}>
                        {_.map(_.get(summaryData, 'guarantees', []), (guarantee, index) => (
                            <div className={'money-block'} key={`${index}-debtor-money-block`}>
                                <Counter
                                    leftValue={{
                                        value: (
                                            <FormattedNumber
                                                value={guarantee?.amount}
                                                decimalPlaces={0}
                                                currency={guarantee?.currency}
                                                currencyStyle={{
                                                    fontSize: '28px',
                                                    fontFamily: 'Trivia Sans Light, sans-serif',
                                                }}
                                                displayCurrency
                                                dontUseBase={true}
                                            />
                                        ),
                                    }}
                                    description={
                                        <FormattedMessage
                                            id={`${LOCALE_PREFIX}.sumOfPrincipals`}
                                            values={{
                                                br: <br />,
                                                currency: guarantee?.currency,
                                            }}
                                        />
                                    }
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="table-container">
                    <Table id={id} module={module} block={block} level={level} />
                </div>
            </div>
        )
    }
}
